import { VALUE_UPDATE_EVENT } from "../../lib/constants.js";
import { computed, createBlock, openBlock, renderSlot, unref, withCtx } from "vue";
import { DtSelectMenu } from "@dialpad/dialtone-vue";
//#region src/components/controls/control_selection.vue
var _sfc_main = /* @__PURE__ */ Object.assign({ name: "DtcControlSelection" }, {
	props: {
		value: {
			type: void 0,
			required: true
		},
		validValues: {
			type: Array,
			default: void 0
		},
		disabled: {
			type: Boolean,
			default: false
		},
		generateLabel: {
			type: Function,
			default: (value) => value.toString()
		}
	},
	emits: [VALUE_UPDATE_EVENT],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const options = computed(() => {
			return props.validValues?.map((selection) => {
				return {
					value: selection,
					label: props.generateLabel(selection)
				};
			});
		});
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(DtSelectMenu), {
				value: __props.value,
				options: options.value,
				disabled: __props.disabled,
				size: "sm",
				onInput: _cache[0] || (_cache[0] = (e) => emit(unref("update:value"), e))
			}, {
				label: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 8, [
				"value",
				"options",
				"disabled"
			]);
		};
	}
});
//#endregion
export { _sfc_main as default };

//# sourceMappingURL=control_selection.vue.js.map